import { render, staticRenderFns } from "./QuestionLayoutG.vue?vue&type=template&id=07bcc110&scoped=true&"
import script from "./QuestionLayoutG.vue?vue&type=script&lang=js&"
export * from "./QuestionLayoutG.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayoutG.vue?vue&type=style&index=0&id=07bcc110&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bcc110",
  null
  
)

export default component.exports